/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function IntegrationTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                           integrationService, applicationService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        applicationService.getApplication(params.applicationId).then(
            (application) => {
                var tableConfiguration = createIntegrationConfig(scope, access, params, application.name);
                deferred.resolve(tableConfiguration);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function createIntegrationConfig(scope, access, params, entityTitle) {

        var applicationId = params.applicationId;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.integration,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'name',
                    title: 'integration.name'},
                { key: 'type',
                  title: 'integration.type',
                  cellContentFunction: (value) =>
                        value in types.integrationType
                            ? $translate.instant(types.integrationType[value].name)
                            : value},
                { key: 'converterName',
                  title: 'converter.converter'}

            ],

            addEntityController: 'AddIntegrationController',

            loadEntities: () => { return integrationService.getApplicationIntegrations(applicationId) },
            loadEntity: (entityId) => {return integrationService.getIntegration(entityId)},
            saveEntity: (entity) => {return integrationService.saveIntegration(entity)},
            deleteEntity: (entityId) => {return integrationService.deleteIntegration(entityId)},

            addEnabled: () => {
                return access == types.access.admin;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('integration.delete-integration-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('integration.delete-integration-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('integration.delete-integrations-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('integration.delete-integrations-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'integration.show-retry-statistics',
                icon: 'equalizer',
                isEnabled: (entity) => {
                    return entity.type === 'HTTP' || entity.type === 'HTTP_V2' || entity.type === 'MQTT_V2' || entity.type === 'MQTT_V2_EMBEDDED';
                },
                onAction: ($event, entity) => {
                    tkDialogs.showIntegrationRetryStatistics($event, entity);
                }
            },
            {
                name: 'integration.show-ul-delivery-statistics',
                icon: 'trending_up',
                isEnabled: (entity) => {
                    return entity.type === 'HTTP' || entity.type === 'HTTP_V2' || entity.type === 'MQTT_V2' || entity.type === 'MQTT_V2_EMBEDDED';
                },
                onAction: ($event, entity) => {
                    tkDialogs.showIntegrationDeliveryStatistics($event, entity);
                }
            },
            {
                name: 'integration.show-dl-statistics',
                icon: 'call_received',
                isEnabled: (entity) => {
                    return entity.type === 'HTTP' || entity.type === 'HTTP_V2' || entity.type === 'MQTT_V2' || entity.type === 'MQTT_V2_EMBEDDED';
                },
                onAction: ($event, entity) => {
                    tkDialogs.showIntegrationDlStatistics($event, entity);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('integration.integrations');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

}



// WEBPACK FOOTER //
// ./src/app/integration/integration-table.config.js